(() => {
  function labelTracking(page) {
    if (!page.hasAttribute('data-realm-track123')) return;
    const labels = {
      'order number': page.dataset.trackingOrderLabel,
      'email or phone number': page.dataset.trackingContactLabel,
      'email/phone number': page.dataset.trackingContactLabel,
      'email/phone': page.dataset.trackingContactLabel,
      'tracking number': page.dataset.trackingNumberLabel
    };
    const normalize = value => (value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    const apply = () => {
      page.querySelectorAll('input').forEach(input => {
        if (input.type === 'hidden' || input.getAttribute('aria-label')?.trim() || input.getAttribute('aria-labelledby')?.trim() || input.labels?.length || input.closest('label')) return;
        const field = normalize(input.getAttribute('placeholder'));
        let name = labels[field];
        if (!name && input.matches('.track123-input')) {
          const group = input.closest('.track123-input-content');
          const providerLabel = group?.querySelector('.track123-input-label');
          // Current Track123 uses visible div labels without a native association.
          // Only its exact single-field wrapper and recognized text identify a field.
          if (providerLabel && providerLabel.closest('.track123-input-content') === group && group.querySelectorAll('input').length === 1 && labels[normalize(providerLabel.textContent)]) {
            name = providerLabel.textContent.trim();
          }
        }
        if (name) input.setAttribute('aria-label', name);
      });
    };
    apply();
    const observer = new MutationObserver(apply);
    observer.observe(page, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['placeholder']});
    page._realmTrackingCleanup = () => observer.disconnect();
  }

  // The stored Shopify body remains authoritative. Only theme presentation and
  // heading semantics are changed in the rendered document.
  function normalizeHeading(page, content) {
    if (!content) return;
    const storedHeadings = Array.from(content.querySelectorAll('h1'));
    const generated = page.querySelector('[data-realm-support-title]');
    if (!storedHeadings.length) return;
    if (generated) (generated.closest('.shopify-policy__title') || generated).remove();
    storedHeadings[0].classList.add('realm-heading');
    for (const heading of storedHeadings.slice(1)) {
      const replacement = document.createElement('h2');
      for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
      while (heading.firstChild) replacement.append(heading.firstChild);
      heading.replaceWith(replacement);
    }
  }

  function bindSupport(page) {
    if (page.dataset.supportBound) return;
    page.dataset.supportBound = 'true';
    labelTracking(page);
    page._realmSupportCleanup = () => page._realmTrackingCleanup?.();
    if (page.hasAttribute('data-realm-native-policy')) {
      const title = page.querySelector('.shopify-policy__title h1');
      const body = page.querySelector('.shopify-policy__body');
      if (title) { title.classList.add('realm-heading'); title.setAttribute('data-realm-support-title', ''); }
      if (body) { body.classList.add('realm-richtext'); body.setAttribute('data-realm-support-content', ''); }
    }
    const content = page.querySelector('[data-realm-support-content]');
    normalizeHeading(page, content);
    const list = page.querySelector('[data-realm-support-topics]');
    if (content && list) {
      let headings = Array.from(content.querySelectorAll('h2'));
      if (!headings.length) headings = Array.from(content.querySelectorAll('h3'));
      headings = headings.filter(heading => heading.textContent.trim());
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = `${page.dataset.supportPrefix}-${index + 1}`;
          let id = base;
          let suffix = 1;
          while (document.getElementById(id)) id = `${base}-${suffix++}`;
          heading.id = id;
        }
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        link.addEventListener('click', () => {
          for (const topic of list.querySelectorAll('a')) topic.removeAttribute('aria-current');
          link.setAttribute('aria-current', 'location');
          window.requestAnimationFrame(() => heading.focus({preventScroll: true}));
        });
        item.append(link);
        list.append(item);
      });
      if (headings.length) {
        list.hidden = false;
        list.closest('nav').hidden = false;
        page.classList.add('realm-support-page--topics');
      }
    }

    const opener = page.querySelector('[data-realm-support-opener]');
    const links = page.querySelector('[data-realm-support-links]');
    if (!opener || !links) return;
    const compact = window.matchMedia('(max-width:1024px)');
    const sync = () => {
      opener.hidden = !compact.matches;
      opener.setAttribute('aria-expanded', String(!compact.matches));
      links.hidden = compact.matches;
    };
    opener.addEventListener('click', () => {
      if (!compact.matches) return;
      links.hidden = !links.hidden;
      opener.setAttribute('aria-expanded', String(!links.hidden));
    });
    compact.addEventListener('change', sync);
    sync();
    page._realmSupportCleanup = () => { compact.removeEventListener('change', sync); page._realmTrackingCleanup?.(); };
  }
  const bindWithin = scope => {
    if (scope.matches?.('[data-realm-support-page]')) bindSupport(scope);
    scope.querySelectorAll('[data-realm-support-page]').forEach(bindSupport);
  };
  bindWithin(document);
  document.addEventListener('shopify:section:load', event => bindWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('[data-realm-support-page]')) event.target._realmSupportCleanup?.();
    event.target.querySelectorAll('[data-realm-support-page]').forEach(page => page._realmSupportCleanup?.());
  });
})();
